import {useRef, useState} from 'react';
import useResizeObserver from 'use-resize-observer';
import {requestContext} from '../../../../../../common/requestContext';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {
  CONTENTS_MOBILE_MAX_WIDTH,
  CONTENTS_PC_MAX_WIDTH,
} from '../constant/viewerConstant';
import {useCheckTextViewerNeedsLoadContent} from '../hook/useCheckTextViewerNeedsLoadContent.hook';
import {useTextViewerCoreOption} from '../hook/useTextViewerCoreOption.hook';
import {PreviewHtmlScrollViewer} from '../presentational/PreviewHtmlListScrollViewer';
import {PreviewTextViewerPositionTracker} from '../presentational/PreviewTextViewerPositionTracker';
import {TextViewerPageCounter} from '../presentational/TextViewerPageCounter';
import {FrameSize} from '../type/FrameSize.interface';

export function PreviewTextViewerContainer({productId}: {productId: number}) {
  const {isMobile} = requestContext.requestInfo.display;

  const {htmlInfoList, currentChapterId} = useTypedSelector(state => ({
    htmlInfoList: state.textViewer.viewData[productId]?.htmlInfoList,
    currentChapterId: state.textViewer.viewData[productId]?.currentChapterId,
  }));

  const [frameSize, setFrameSize] = useState<FrameSize>({
    width: 0,
    height: 0,
  });
  const {ref: viewerWrapperRef} = useResizeObserver<HTMLDivElement>({
    onResize: ({width, height}) => {
      if (!width || !height) {
        return;
      }
      setFrameSize({width, height: document.documentElement.clientHeight});
    },
  });

  const option = useTextViewerCoreOption({
    size: frameSize,
    isMobile,
  });
  useCheckTextViewerNeedsLoadContent({productId, size: frameSize});

  const contentWrapperRef = useRef<HTMLDivElement>(null);

  return (
    <div
      className="min-h-full w-full"
      style={{
        backgroundColor: option.backgroundColor,
      }}
    >
      <div
        ref={viewerWrapperRef}
        className="mx-auto min-h-full w-full"
        style={{
          maxWidth: isMobile
            ? CONTENTS_MOBILE_MAX_WIDTH
            : CONTENTS_PC_MAX_WIDTH,
        }}
      >
        {htmlInfoList && (
          <PreviewHtmlScrollViewer
            ref={contentWrapperRef}
            htmlInfoList={htmlInfoList}
            option={option}
            productId={productId}
            currentChapterId={currentChapterId}
          />
        )}
        <TextViewerPageCounter
          productId={productId}
          size={frameSize}
          isPreview={true}
        />
        <PreviewTextViewerPositionTracker
          productId={productId}
          size={frameSize}
          wrapperRef={contentWrapperRef}
        />
      </div>
    </div>
  );
}
